import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice';
import deviceSlice from './deviceSlice';
import assetsSlice from './assetsSlice';
import departmentReducer from './departmentmanagementSlice';
import allRequestsReducer from './allRequestsSlice';
import pendingApprovalsReducer from './approvalsSlice';
import categoriesReducer from './categoriesSlice';
import authReducer from './authSlice';
import companyReducer from './companySlice';
import notificationsReducer from './notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userSlice,
    devices: deviceSlice,
    assets: assetsSlice,
    department: departmentReducer,
    allRequests: allRequestsReducer,
    approvals: pendingApprovalsReducer,
    categories: categoriesReducer,
    companies: companyReducer,
    notifications: notificationsReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
